if (!customElements.get('product-banner')) {
  customElements.define('product-banner', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.submitButton = this.querySelector('[type="submit"]');
      this.mainProductSection = this.closest('.section-main-product')
      if (!this.mainProductSection) return;
      this.rechargeWidget = this.mainProductSection.querySelector('.recharge-subscription-widget') || this.mainProductSection.querySelector('product-selling-plan')
      if (this.rechargeWidget) this.mainProductSection.addEventListener('sellingPlanChange', this.update.bind(this))
      this.variants = this.mainProductSection.querySelector('variant-radios')
      this.contentWrapper = this.querySelector('.main-product-banner-content')
      if (this.variants) this.variants.addEventListener('change', this.update.bind(this))

      this.formId = this.dataset.formId
      this.form = this.mainProductSection.querySelector('#' + this.formId);
      this.formButton = this.form.querySelector('[type="submit"]');

      var options = {
		    rootMargin: '0px'
			}

			var observer = new IntersectionObserver(this.intersectionCallback.bind(this), options);
			observer.observe(this.mainProductSection)
    }

    intersectionCallback(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {

          const rect = entry.target.getBoundingClientRect()
	        const height = rect.height
	        const top = rect.top

	        this.classList.add('-translate-y-full')
	        this.classList.remove('translate-y-0')

        } else {
	        // Filtering for leaving at the top of the screen
	        const rect = entry.target.getBoundingClientRect()
	        const height = rect.height
	        const top = rect.top
	        if ((height + top) <= 0) {
	        	this.classList.remove('-translate-y-full')
		        this.classList.add('translate-y-0')
	        }
        }
      })
    }

    update(evt) {
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.setAttribute('disabled', true);
      this.submitButton.classList.add('loading');

      const url = window.location.pathname + (window.location.search ? (window.location.search + '&') : '?') + 'section_id=main-product-banner'
      fetch(`${url}`)
        .then((response) => response.text())
        .then((response) => {
          const html = new DOMParser().parseFromString(response, 'text/html')
          var newContentWrapper = html.querySelector('.main-product-banner-content')
          this.contentWrapper.innerHTML = newContentWrapper.innerHTML

          setTimeout(() => {
            this.querySelector('.price').innerHTML = this.formButton.querySelector('.product-form__price').innerHTML;
          }, 100)

        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (!this.error) this.submitButton.removeAttribute('disabled');
        });
    }
  });
}